import { Module } from '../../../../../../../api/module';
import { UserModule } from '../../../../../../my-methods/api/methodsApi';

export function sortModulesByCatalogName(modules: UserModule[]): UserModule[] {
  return modules.sort((a, b) => a.catalogName.localeCompare(b.catalogName));
}

export function sortSubModulesByNiceName(subModules: (Module | UserModule)[]): (Module | UserModule)[] {
  return subModules.sort((a, b) => a.niceName.localeCompare(b.niceName));
}
